module.exports = __webpack_public_path__ + "img/icon_unclassigied_msg_reset.svg";